import {ReactElement, useCallback, useEffect, useRef, useState} from 'react';
import {Link, useUrl} from '@shopify/hydrogen';

import classNames from 'classnames';
import {filterByProductGroupOptions} from '../constants';
import {useShopFilterUrlEncode} from '../hooks/useShopFilterUrlEncode.client';
import {getSearchQuery} from '../utils/shopFilterHelpers';

export default function ShopHeader(): ReactElement {
  const {href} = useUrl();
  const containerRef = useRef<HTMLDivElement>();
  const [overflowing, setOverflowing] = useState(false);

  const calculateOverflow = useCallback(() => {
    if (containerRef.current) {
      setOverflowing(
        containerRef.current.offsetWidth < containerRef.current.scrollWidth,
      );
    }
  }, []);

  useEffect(() => {
    calculateOverflow();
    window.addEventListener('resize', calculateOverflow);
    return () => window.removeEventListener('resize', calculateOverflow);
  }, [calculateOverflow]);

  const {filterParams} = useShopFilterUrlEncode();

  return (
    <section>
      <div className="shop-header">
        <div
          className={classNames('container', {'overflow-mask': overflowing})}
          id="shop-header-container"
          ref={containerRef}
        >
          <div className="category-tab-menu">
            <Link
              to={`/shop?${getSearchQuery(
                href,
                {
                  ...filterParams,
                  ...{list: null},
                },
                {includeKeys: ['list', 'searchTokens']},
              )}`}
              className={classNames('category-tab-menu__item', {
                active: filterParams.list === null,
              })}
            >
              All whisky
            </Link>
            {Object.values(filterByProductGroupOptions).map(
              ({value, label}) => (
                <Link
                  to={`/shop/?${getSearchQuery(
                    href,
                    {
                      ...filterParams,
                      ...{list: value},
                    },
                    {includeKeys: ['list', 'searchTokens']},
                  )}`}
                  key={value}
                  className={classNames('category-tab-menu__item', {
                    active: value === filterParams.list,
                  })}
                >
                  {label}
                </Link>
              ),
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
